module.exports = __webpack_public_path__ + "static/media/8.7bd54f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/8.jpg
// module id = 399
// module chunks = 0